import type { PersistedDefaultTabProps } from '@talos/kyoko';
import type { BalancesBlotterColumnSpecification, BalancesV2TabProps } from './types';

export const DEFAULT_BY_COUNTERPARTY_TAB_ID = 'by-counterparty-balances';
export const DEFAULT_BY_ASSET_TAB_ID = 'by-asset-balances';

export const defaultSharedColumns = [
  'Amount',
  'Equivalent.Amount',
  'AvailableAmount',
  'Equivalent.AvailableAmount',
  'OutstandingBuy',
  'OutstandingSell',
  'Equivalent.OutstandingBuy',
  'Equivalent.OutstandingSell',
] satisfies BalancesBlotterColumnSpecification[];

export const defaultByCounterpartyColumns = [
  'reconWarning',
  { field: 'marketAccountGroup', initialRowGroupIndex: 0, initialRowGroup: false, initialHide: true },
  { field: 'marketAccountName', initialRowGroupIndex: 1, initialRowGroup: true, initialHide: true },
  'Currency',
  ...defaultSharedColumns,
] satisfies BalancesBlotterColumnSpecification[];

export const defaultByAssetColumns = [
  'reconWarning',
  { field: 'Currency', initialRowGroup: true, initialHide: true },
  'marketAccountName',
  ...defaultSharedColumns,
] satisfies BalancesBlotterColumnSpecification[];

const byCounterpartyTab: PersistedDefaultTabProps<BalancesV2TabProps> = {
  label: 'By Counterparty',
  id: DEFAULT_BY_COUNTERPARTY_TAB_ID,
  closable: true,
  editable: true,
  defaultColumns: defaultByCounterpartyColumns,
  defaultFilter: {},
  showZeroBalances: false,
  showTotals: true,
};

const byAssetTab: PersistedDefaultTabProps<BalancesV2TabProps> = {
  label: 'By Instrument',
  id: DEFAULT_BY_ASSET_TAB_ID,
  closable: true,
  editable: true,
  defaultColumns: defaultByAssetColumns,
  defaultFilter: {},
  showZeroBalances: false,
  showTotals: true,
};

export const defaultBalancesTabs = [byCounterpartyTab, byAssetTab];
